import store from '@/store';

// 경로 url 패턴을 생성하는 함수
const asPattern = (str = '') => {
  const exp = str
    .split('/')
    .filter(elem => !!elem)
    .reduce((prev, next) => {
      if (prev) return prev + `(\\/${next})`;
      else return prev + `(\\/${next})`;
    }, '');

  return new RegExp(`${exp}(\/.*)?`, 'gsi');
};
const generatePattern = (...path) => {
  if (Array.isArray(path)) return path.map(pathPiece => asPattern(pathPiece));
  else return asPattern(path);
};

const isBlocked = (path, blackList = []) => {
  return generatePattern(...blackList).filter(elem => elem.test(path)).length > 0;
};

const isPassed = (path, whiteList = []) => {
  return whiteList.includes(path);
};

export const immigration = (to, from, next, router, blackList, whiteList) => {
  const { path } = to;
  if (store.getters['user/getAccessToken']) return true;
  if (isPassed(path, whiteList)) return true;

  return !isBlocked(path, blackList);
};

// const routerGo = (router, next, path) => {
//   next(false);
//   setTimeout(() => {
//     window.location.replace(path);
//   }, 0);
// };
